module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-es.a0ccd422.svg";